import { useContext } from 'react';
import { uiActionsContext } from './provider';

export function useUiAction() {
  const { perform } = useContext(uiActionsContext);
  return {
    perform,
  };
}
